import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import ToolTip from "app/routes/Scheduling/ToolTip";
import RoundButton from "app/components/Programs/Buttons/RoundButton";

interface Props {
  title: string;
  onChange: (value: boolean) => any;
  toolTipText?: string | string[];
  titleToolTipText?: string | string[] | null;
  description?: string;
  secondDesc?: string;
  textFirstBtn: string;
  textSecondBtn: string;
  defaultValue?: boolean;
}

const ToggleButtons = ({
    title,
    onChange = null,
    titleToolTipText = null,
    description,
    secondDesc,
    textFirstBtn,
    textSecondBtn,
    defaultValue = true,
}: Props) => {
  const [isAllowed, setIsAllowed] = useState(defaultValue);

  useEffect(() => {
    setIsAllowed(defaultValue);
  }, [defaultValue]);

  const handleToggle = (value: boolean) => {
    setIsAllowed(value);
    onChange(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.first_row}>
        <div className={styles.title}>{title}</div>
        {titleToolTipText && <ToolTip text={titleToolTipText} />}
      </div>
      {description && <p className={styles.description}>{description}</p>}
      <br/>
      {secondDesc && <p className={styles.description}>{secondDesc}</p>}
      <div className={styles.buttons}>
        <RoundButton
          customStyle={`${styles.button} ${isAllowed ? styles.active : ""}`}
          onClick={() => handleToggle(true)}
        >
          <p className={styles.preview_text}>{textFirstBtn}</p>
        </RoundButton>
        <RoundButton
          customStyle={`${styles.button} ${!isAllowed ? styles.active : ""}`}
          onClick={() => handleToggle(false)}
        >
          <p className={styles.preview_text}>{textSecondBtn}</p>
        </RoundButton>
      </div>
    </div>
  );
};

export default ToggleButtons;
